import { useTheme } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

import Box from "@subly/s1/ui/atom/Box";
import Button from "@subly/s1/ui/base/Button";

import { useWelcome } from "../fabric";


const Row = ({ label, value }: { label: string; value?: boolean }) => {
	const theme = useTheme();
	const text = value ? "Enabled" : "Disabled";

	const style = {
		content: {
			justifyContent: "space-between",
			alignItems: "center",
			py: 1,
			borderTop: `1px solid ${theme.palette.divider}`
		}
	} satisfies SxProps;

	return (
		<Box sx={style.content}>
			<Box.Column>
				<Typography variant="subtitle2" color="textSecondary">{label}</Typography>
				<Typography variant="h6" color="secondary">{text}</Typography>
			</Box.Column>
			<Switch color="secondary" checked={value} disabled />
		</Box>
	);
};

export default function Done() {
	const welcome = useWelcome();
	const style = {
		root: {
			maxWidth: "sm",
			width: "100%",
			mx: "auto"
		},
		subheader: { py: 2 },
		button: { mt: 4 }
	} satisfies SxProps;

	return (
		<Box.Column sx={style.root}>
			<Box.Column sx={style.subheader}>
				<Typography variant="h3">Enable Subly</Typography>
				<Typography color="textSecondary">Switch Subly into Production Mode</Typography>
			</Box.Column>

			<Box.Column gap={1}>
				<Row label="Article Unlocking" value />
				<Row label="Pass Unlocking" value={Boolean(welcome.data?.pricing.pass)} />
			</Box.Column>

			<Button.Link to="/" variant="contained" color="secondary" fullWidth sx={style.button}>
				Go to dashboard
			</Button.Link>
		</Box.Column>
	);
};